import { createApi } from '@reduxjs/toolkit/query/react';
import config from 'config/index';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import { EUserType } from 'types/accessControll.types';
import type { TExtendedApplication } from 'types/application.types';
import type { TPaginationResult } from '../api-common.types';
import type { TPaginationJobApplicationsRequest } from './applications.api.types';

const reducerPath = 'applications' as const;
const path = 'v1/applications' as const;

export const applicationsApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  tagTypes: ['Application'],
  endpoints: (builder) => ({
    findPaginatedJobApplications: builder.query<
      TPaginationResult<TExtendedApplication>,
      TPaginationJobApplicationsRequest
    >({
      query: (payload) => {
        console.log('useFindPaginatedJobApplicationsQuery searchParams', payload);
        return {
          url: `/paginated-find`,
          method: 'POST',
          data: payload,
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
      providesTags: ['Application'],
    }),

    getApplicationSummary: builder.query<TExtendedApplication, { applicationId: string }>({
      query: (query) => {
        return {
          url: `/${query.applicationId}/summary`,
          method: 'GET',
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
      providesTags: ['Application'],
    }),

    rejectApplication: builder.mutation<TExtendedApplication, any>({
      query: (applicationId: string) => {
        console.log('rejectApplication applicationId', applicationId);
        return {
          url: `/${applicationId}/reject`,
          method: 'GET',
          headers: { 'X-Access-Control': EUserType.RECRUITER },
        };
      },
    }),

    silencePublishErrors: builder.mutation<void, { applicationId: string }>({
      query: ({ applicationId }) => {
        return {
          url: `/${applicationId}/silence-publish-errors`,
          method: 'POST',
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
    }),
  }),
});

export const {
  // Queries
  useFindPaginatedJobApplicationsQuery,
  useGetApplicationSummaryQuery,
  // Mutations
  useRejectApplicationMutation,
  useSilencePublishErrorsMutation,
} = applicationsApi;
